import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import CopyrightIcon from '@material-ui/icons/Copyright';
import { useStyles } from './FooterStyles';

export const MemoizedFooter = React.memo(() => {
	const classes = useStyles();
	return (
		<AppBar position="fixed" className={classes.footer}>
			<Toolbar className={classes.footerToolbar}>
				<CopyrightIcon />				
				<Link
					href="https://www.kaliopa.si/"
					target="_blank"
					rel="noopener noreferrer"
					color="inherit">
					Kaliopa d.o.o.  {new Date().getFullYear()}
				</Link>					
				<Link
					href="https://gis.iobcina.si/dokumenti/vrhnika/Pogoji_uporabe_Vrhnika.pdf"
					target="_blank"
					rel="noopener noreferrer"
					color="inherit"
					style={{ marginLeft: "auto" }}>
					Obvestilo o varstvu osebnih podatkov
				</Link>				
			</Toolbar>
		</AppBar>
	);
});
